import { z } from 'zod';
export var JsonLogicInStringArray = z.object({
  "in": z.tuple([z.object({
    "var": z.string()
  }), z.string().array()])
});
export var JsonLogicInNumberArray = z.object({
  "in": z.tuple([z.object({
    "var": z.string()
  }), z.number().array()])
});
var JsonLogicSome = z.object({
  some: z.tuple([z.object({
    "var": z.string()
  }), z.object({
    and: z.tuple([z.object({
      some: z.tuple([z.object({
        "var": z.literal('tags')
      }), z.object({
        '==': z.tuple([z.object({
          "var": z.literal('')
        }), z.string()])
      })])
    }), z.object({
      '==': z.tuple([z.object({
        "var": z.string()
      }), z.string()])
    })])
  })])
});
var JsonLogicLessThan = z.object({
  '<': z.tuple([z.object({
    "var": z.string()
  }), z.object({
    "var": z.string()
  })])
});
var JsonLogicGreaterThan = z.object({
  '>': z.tuple([z.object({
    "var": z.string()
  }), z.object({
    "var": z.string()
  })])
});
var JsonLogicLessThanOrEqualTo = z.object({
  '<=': z.tuple([z.object({
    "var": z.string()
  }), z.object({
    "var": z.string()
  })])
});
var JsonLogicGreaterThanOrEqualTo = z.object({
  '>=': z.tuple([z.object({
    "var": z.string()
  }), z.object({
    "var": z.string()
  })])
});
var JsonLogicBoolean = z.object({
  '==': z.tuple([z.object({
    "var": z.string()
  }), z["boolean"]()])
});
export var JsonLogic = z.union([JsonLogicInStringArray, JsonLogicInNumberArray, JsonLogicSome, JsonLogicLessThan, JsonLogicGreaterThan, JsonLogicLessThanOrEqualTo, JsonLogicGreaterThanOrEqualTo, JsonLogicBoolean]);